<template>
    <el-tooltip
        effect='dark'
        :disabled="isSyncEnabled"
        content='Rematch users to enable use of sync'
        placement='bottom'
    >
        <span style="display:inline-block">
            <el-button
                v-if="!$apollo.loading"
                :loading="loading"
                @click="toggleCheck"
                :icon="enabled ? 'fe fe-zap-off fe-just-off' : 'fe fe-zap fe-just-off'"
                :type="!enabled ? 'success' : 'danger'"
                :disabled="!isSyncEnabled"
            >{{ enabled ? "Disable automated sync" : "Enable automated sync" }}</el-button>
        </span>
    </el-tooltip>
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import provider from '../../libs/provider';
export default {
    props: ["isSyncEnabled", "isOrganisation"],

    data() {
        return {
            loading: false,
            enabled: null,
            settingsQuery: {
                school: `{
                    Settings {
                        id
                        auto_enabled
                    }
                }`,
                organisation: `query Settings($type: SettingsTypeEnum!) {
                    Settings(type: $type) {
                        employee_active
                    }
                }`
            },
        };
    },

    apollo: {
        enabledSchool: {
            query: gql`
                {
                    Settings {
                        id
                        auto_enabled
                    }
                }
            `,
            update(r) {
                if (!this.isOrganisation) {
                    this.enabled = r.Settings.auto_enabled;
                }
            }
        },

        enabledOrganisation: {
            query: gql`
                query Settings($type: SettingsTypeEnum!) {
                    Settings(type: $type) {
                        id
                        auto_enabled
                    }
                }
            `,
            variables() {
                return {
                    type: "organisation"
                }
            },
            update(r) {
                if (this.isOrganisation) {
                    this.enabled = r.Settings.auto_enabled;
                }
            }
        }
    },

    methods: {
        toggleCheck() {
            if (this.enabled) {
                return this.toggle();
            }
            
            if (this.providerCode === "apl") {
                this.toggle();
            } else {
                this.$confirm(
                    `Enable automatic mode to automatically create and delete users when they are added and removed in your schools 
                    MIS. If you have enabled the creation of users in Settings > Advanced, any users not already matched (or ignored) 
                    will be created. If you have enabled the deletion of users in Settings > Advanced Settings, any matched users 
                    will be suspended (and later deleted) if the user is no longer visible in your MIS.`,
                    "Warning",
                    {
                        confirmButtonText: "OK",
                        cancelButtonText: "Cancel",
                        type: "warning"
                    }
                ).then(() => {
                    this.toggle();
                });
            }
        },
        toggle() {
            this.loading = true;
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation EnableAutomaticMode($enabled: Boolean!, $type: SettingsTypeEnum!) {
                            EnableAutomaticMode(enabled: $enabled, type: $type)
                        }
                    `,
                    variables: {
                        enabled: !this.enabled,
                        type: this.isOrganisation ? "organisation" : "school"
                    },
                    update: (store, { data: { EnableAutomaticMode } }) => {
                        this.enabled = !this.enabled;
                    }
                })
                .then(r => {
                    this.loading = false;
                })
                .catch(e => {
                    this.loading = false;
                    this.$message.error("Failed action");
                });
        }
    }
};
</script>
